// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper___INSK0","wrapper_reverse":"wrapper_reverse___vbmSZ","image":"image___SoiKB","p_wrapper":"p_wrapper___YI7WD","title":"title___OOMh3"};